<template>
	<div class="register-container">
		<el-card class="register-form">
			<div class="form-header">
				<h2>用户注册</h2>
				<p>请填写注册信息</p>
			</div>
			
			<el-tabs v-model="activeTab" @tab-click="handleTabClick">
				<el-tab-pane label="手机号注册" name="phone">
					<el-form ref="phoneRegisterForm" :model="phoneRegisterForm" :rules="phoneRegisterRules" label-width="0">
						<el-form-item prop="phone">
							<el-input 
								v-model="phoneRegisterForm.phone" 
								placeholder="请输入手机号"
								prefix-icon="el-icon-mobile-phone">
							</el-input>
						</el-form-item>
						
						<el-form-item prop="code">
							<div class="code-input">
								<el-input 
									v-model="phoneRegisterForm.code" 
									placeholder="请输入验证码"
									prefix-icon="el-icon-key">
								</el-input>
								<el-button 
									type="primary" 
									:disabled="codeCountdown > 0"
									@click="sendCode">
									{{ codeCountdown > 0 ? `${codeCountdown}s` : '发送验证码' }}
								</el-button>
							</div>
						</el-form-item>
						
						<el-form-item prop="username">
							<el-input 
								v-model="phoneRegisterForm.username" 
								placeholder="请输入用户名"
								prefix-icon="el-icon-user">
							</el-input>
						</el-form-item>
						
						<el-form-item prop="email">
							<el-input 
								v-model="phoneRegisterForm.email" 
								placeholder="请输入邮箱（可选）"
								prefix-icon="el-icon-message">
							</el-input>
						</el-form-item>
						
						<el-form-item>
							<el-button 
								type="primary" 
								class="register-btn" 
								:loading="registering"
								@click="handlePhoneRegister">
								注册
							</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				
				<el-tab-pane label="用户名注册" name="username">
					<el-form ref="usernameRegisterForm" :model="usernameRegisterForm" :rules="usernameRegisterRules" label-width="0">
						<el-form-item prop="username">
							<el-input 
								v-model="usernameRegisterForm.username" 
								placeholder="请输入用户名"
								prefix-icon="el-icon-user"
								@blur="checkUsername">
							</el-input>
						</el-form-item>
						
						<el-form-item prop="email">
							<el-input 
								v-model="usernameRegisterForm.email" 
								placeholder="请输入邮箱"
								prefix-icon="el-icon-message"
								@blur="checkEmail">
							</el-input>
						</el-form-item>
						
						<el-form-item prop="password">
							<el-input 
								v-model="usernameRegisterForm.password" 
								type="password" 
								placeholder="请输入密码"
								prefix-icon="el-icon-lock">
							</el-input>
						</el-form-item>
						
						<el-form-item prop="confirmPassword">
							<el-input 
								v-model="usernameRegisterForm.confirmPassword" 
								type="password" 
								placeholder="请确认密码"
								prefix-icon="el-icon-lock">
							</el-input>
						</el-form-item>
						
						<el-form-item>
							<el-button 
								type="primary" 
								class="register-btn" 
								:loading="registering"
								@click="handleUsernameRegister">
								注册
							</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
			
			<div class="form-footer">
				<p>已有账号？<el-button type="text" @click="goToLogin">立即登录</el-button></p>
			</div>
		</el-card>
	</div>
</template>

<script>
export default {
	name: 'Register',
	data() {
		const validateConfirmPassword = (rule, value, callback) => {
			if (value !== this.usernameRegisterForm.password) {
				callback(new Error('两次输入的密码不一致'));
			} else {
				callback();
			}
		};
		
		return {
			activeTab: 'phone',
			phoneRegisterForm: {
				phone: '',
				code: '',
				username: '',
				email: ''
			},
			usernameRegisterForm: {
				username: '',
				email: '',
				password: '',
				confirmPassword: ''
			},
			phoneRegisterRules: {
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
					{ pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur' }
				],
				username: [
					{ required: true, message: '请输入用户名', trigger: 'blur' },
					{ min: 3, max: 20, message: '用户名长度在3到20个字符', trigger: 'blur' }
				],
				email: [
					{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
				]
			},
			usernameRegisterRules: {
				username: [
					{ required: true, message: '请输入用户名', trigger: 'blur' },
					{ min: 3, max: 20, message: '用户名长度在3到20个字符', trigger: 'blur' }
				],
				email: [
					{ required: true, message: '请输入邮箱', trigger: 'blur' },
					{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
				],
				confirmPassword: [
					{ required: true, message: '请确认密码', trigger: 'blur' },
					{ validator: validateConfirmPassword, trigger: 'blur' }
				]
			},
			registering: false,
			codeCountdown: 0
		}
	},
	methods: {
		handleTabClick() {
			// 切换标签时重置表单
			this.$nextTick(() => {
				if (this.activeTab === 'phone') {
					this.$refs.phoneRegisterForm?.resetFields();
				} else {
					this.$refs.usernameRegisterForm?.resetFields();
				}
			});
		},
		
		async sendCode() {
			if (!this.phoneRegisterForm.phone) {
				this.$message.warning('请先输入手机号');
				return;
			}
			
			if (!/^1[3-9]\d{9}$/.test(this.phoneRegisterForm.phone)) {
				this.$message.warning('请输入正确的手机号');
				return;
			}
			
			try {
				const response = await this.$http.post('/api/auth/send-code', null, {
					params: {
						phone: this.phoneRegisterForm.phone,
						type: 'register'
					}
				});
				
				this.$message.success('验证码发送成功');
				this.startCodeCountdown();
			} catch (error) {
				console.error('发送验证码失败:', error);
				const errorMsg = error.response?.data?.error || '发送验证码失败';
				this.$message.error(errorMsg);
			}
		},
		
		startCodeCountdown() {
			this.codeCountdown = 60;
			const timer = setInterval(() => {
				this.codeCountdown--;
				if (this.codeCountdown <= 0) {
					clearInterval(timer);
				}
			}, 1000);
		},
		
		async handlePhoneRegister() {
			this.$refs.phoneRegisterForm.validate(async (valid) => {
				if (valid) {
					this.registering = true;
					try {
						const response = await this.$http.post('/api/auth/phone-register', this.phoneRegisterForm);
						
						this.$message.success('注册成功！请登录');
						this.$router.push('/login');
					} catch (error) {
						console.error('注册失败:', error);
						const errorMsg = error.response?.data?.error || '注册失败';
						this.$message.error(errorMsg);
					} finally {
						this.registering = false;
					}
				}
			});
		},
		
		async checkUsername() {
			if (!this.usernameRegisterForm.username) return;
			
			try {
				const response = await this.$http.get('/api/auth/check-username', {
					params: { username: this.usernameRegisterForm.username }
				});
				
				if (response.data.exists) {
					this.$message.warning('用户名已存在');
				}
			} catch (error) {
				console.error('检查用户名失败:', error);
			}
		},
		
		async checkEmail() {
			if (!this.usernameRegisterForm.email) return;
			
			try {
				const response = await this.$http.get('/api/auth/check-email', {
					params: { email: this.usernameRegisterForm.email }
				});
				
				if (response.data.exists) {
					this.$message.warning('邮箱已被使用');
				}
			} catch (error) {
				console.error('检查邮箱失败:', error);
			}
		},
		
		async handleUsernameRegister() {
			this.$refs.usernameRegisterForm.validate(async (valid) => {
				if (valid) {
					this.registering = true;
					try {
						const response = await this.$http.post('/api/auth/register', {
							username: this.usernameRegisterForm.username,
							email: this.usernameRegisterForm.email,
							password: this.usernameRegisterForm.password
						});
						
						this.$message.success('注册成功！请登录');
						this.$router.push('/login');
					} catch (error) {
						console.error('注册失败:', error);
						const errorMsg = error.response?.data?.error || '注册失败';
						this.$message.error(errorMsg);
					} finally {
						this.registering = false;
					}
				}
			});
		},
		
		goToLogin() {
			this.$router.push('/login');
		}
	}
}
</script>

<style scoped>
.register-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	padding: 20px;
}

.register-form {
	background: white;
	padding: 40px;
	border-radius: 10px;
	box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
	width: 100%;
	max-width: 450px;
}

.form-header {
	text-align: center;
	margin-bottom: 30px;
}

.form-header h2 {
	color: #303133;
	margin-bottom: 10px;
}

.form-header p {
	color: #909399;
	margin: 0;
}

.code-input {
	display: flex;
	gap: 10px;
}

.code-input .el-input {
	flex: 1;
}

.code-input .el-button {
	width: 120px;
}

.register-btn {
	width: 100%;
}

.form-footer {
	text-align: center;
	margin-top: 20px;
	padding-top: 20px;
	border-top: 1px solid #ebeef5;
}

.form-footer p {
	color: #909399;
	margin: 0;
}
</style> 